import React, { Component, Fragment } from 'react';
import SimpleLayout from '../SimpleLayout';

export class Error extends React.Component {
    constructor(props) {
        super(props);
    }

    goBack = () => {
        this.props.history.goBack()
    }

    goBackAStep = () => {
        this.props.history.go(-2)
    }

    render() {
        return (
<div className="main__container simple-layout">
                <nav className="navigation-navbar builder-desktop-navbar builder-navbar navbar navbar-default" style={{height:61} }>
                        <div className="container-fluid height100">
                        <div className="navbar-header height100 displayflex" style={{flex:1} }>
                                <div className="brand displayflex aligncenter height100">
                                <a href="/" class="displayflex aligncenter height100" style={{
                                    color:'#323c55', fontSize: 18, letterSpacing: -.5, padding:'0px !important' }}>
                                    <div class="displayflex aligncenter height100 mr5" style={{ width: 25, overflow: 'hidden'  }}>
                                        <img src="https://teamsly-cdn-cuc0cvgwakbtarf9.z01.azurefd.net/images/logo-name.svg" alt="Productboard " class="site-header__logo-image" style={{ minWidth: 148}} />
                                    </div>
                                    Teams stack
                                </a>
                                </div>
                            </div>
                        </div>
                    </nav>
                    <section className="app-builder__body">
                    <div className="app-style-page app-builder-page layout displayflex aligncenter flexcolumn">
                        <div class="displayflex mt40 aligncenter flexcolumn" style={{maxWidth:600}}>
                            <img className="my30" style={{width:500}} src="https://teamsly-cdn-cuc0cvgwakbtarf9.z01.azurefd.net/images/500-error.png" />
                            <div class="head-m mt40">We can't load your content right now.</div>
                            <div class="subhead-m mt20 mb30 textcenter">
                        We're sorry! We've notified our support team and they're on the case. Some things you can try right now:
                    </div>
                    <div class="col-lg-12">
                                <div class="link" style={{
                                    width: 350,
                                    margin: 'auto'}}>
                            <div>
                                        <i style={{ fontSize: 20,color:'green'}} class="ms-Icon ms-Icon--CheckMark"></i>
                                        <a href="" className="subhead-m" onClick={()=>this.goBack()}> Retry </a>
                            </div>
                            <div>
                                        <i style={{ fontSize: 20, color: 'green' }} class="ms-Icon ms-Icon--CheckMark"></i>
                                        <a href="" className="subhead-m" onClick={() => this.goBackAStep()} > Go back a step </a>
                            </div>
                            <div>
                                        <i style={{ fontSize: 20, color: 'green' }} class="ms-Icon ms-Icon--CheckMark"></i>
                                        <a className="subhead-m" href="mailto:support@teamslyapp.com"> Contact your friendly support team </a>
                            </div>
                        </div>
                    </div>
        </div>

                        </div>
                    </section>
                </div>
            
        );
    }
}


export default Error;



